import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Injectable, inject, signal } from '@angular/core';
import { Observable, defer, finalize } from 'rxjs';
import { GsLoaderComponent } from '../../shared/ui/loader/gs-loader.component';

@Injectable({ providedIn: 'root' })
export class LoaderService {
  private readonly overlay = inject(Overlay);

  private readonly pending = signal(0);
  private overlayRef: OverlayRef | null = null;

  public begin(): void {
    this.pending.update(count => count + 1);
    this.attach();
  }

  public end(): void {
    this.pending.update(count => Math.max(0, count - 1));

    if (this.pending() === 0) {
      this.detach();
    }
  }

  public track<T>(source$: Observable<T>): Observable<T> {
    return defer(() => {
      this.begin();
      return source$.pipe(finalize(() => this.end()));
    });
  }

  private attach(): void {
    if (this.overlayRef) {
      return;
    }

    this.overlayRef = this.overlay.create({
      positionStrategy: this.overlay
        .position()
        .global()
        .centerHorizontally()
        .centerVertically(),
      scrollStrategy: this.overlay.scrollStrategies.block(),
      hasBackdrop: true,
      backdropClass: 'gs-loader-backdrop',
    });
    this.overlayRef.attach(new ComponentPortal(GsLoaderComponent));
  }

  private detach(): void {
    this.overlayRef?.dispose();
    this.overlayRef = null;
  }
}
